import { SessionModel } from "../models/session";
import { createDataStore } from "../utils/data_score";

const SESSION_KEY = "marjo90rie-session";

const sessionStore = createDataStore<SessionModel | undefined>(
  getSessionFromLocalStorage()
);

export const useSession = sessionStore.useData;
export const createSession = (session: SessionModel) => setSession(session);
export const deleteSession = () => setSession(undefined);

function setSession(session: SessionModel | undefined) {
  if (session === undefined) {
    localStorage.removeItem(SESSION_KEY);
  } else {
    localStorage.setItem(SESSION_KEY, JSON.stringify(session));
  }
  sessionStore.setData(session);
}

function getSessionFromLocalStorage(): SessionModel | undefined {
  const maybeStrSession = localStorage.getItem(SESSION_KEY);
  if (maybeStrSession === null) {
    return undefined;
  }
  try {
    return JSON.parse(maybeStrSession);
  } catch {
    return undefined;
  }
}
